export default __webpack_public_path__ + "static/media/cancel.07a54e48.svg";